import { updateProfile } from 'flow/actions/profile-actions';
import Loading from 'flow/components/ui-components/Loading';
import Button from 'flow/components/ui-components/Button';
import CharacterCountInput from 'flow/components/ui-components/CharacterCountInput';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import {
    operatorNoteIsOverLimit,
    OPERATOR_NOTE_COUNT_FROM,
    OPERATOR_NOTE_MAX_LENGTH,
} from 'flow/utils/constants/profile-constants';
import { generatePath } from 'flow/utils/router-utils';
import { fromJS } from 'immutable';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import Page from '../Page';

const ProfileOperatorNote = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
    }>();

    const { getProfile } = useProfiles(extensionKey);

    const profile = getProfile(profileKey);

    const [note, setNote] = useState<string>();

    useEffect(() => {
        setNote(profile?.get('operatorNote'));
    }, [profile, profileKey]);

    if (!profile) {
        return <Loading />;
    }

    const noteIsOverLimit = operatorNoteIsOverLimit(note);

    const onSubmit = () => {
        dispatch(
            updateProfile(
                extensionKey,
                fromJS({
                    key: profileKey,
                    operatorNote: note,
                }),
            ),
        );

        history.push(
            generatePath(routes['settings.profiles.profileKey'], {
                extensionKey,
                profileKey,
            }),
        );
    };

    return (
        <Page
            header={profile.get('description')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.profiles.profileKey'], {
                        extensionKey,
                        profileKey,
                    }),
                )
            }
        >
            <CharacterCountInput
                label={i18next.t('profilechooser.message')}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                disabled={!profile.get('editable')}
                maxLength={OPERATOR_NOTE_MAX_LENGTH}
                characterCountFrom={OPERATOR_NOTE_COUNT_FROM}
            />

            <div className="mt-6 flex justify-end">
                <Button
                    color="primary"
                    className="min-w-max px-5"
                    onClick={onSubmit}
                    disabled={!profile.get('editable') || noteIsOverLimit}
                >
                    {i18next.t('navigate.save')}
                </Button>
            </div>
        </Page>
    );
};

export default ProfileOperatorNote;
